/* kb-cart: eigen winkelwagen (drawer op desktop, bottom sheet op mobiel) volgens het Claude Design-ontwerp "Winkelwagen".
   - Vervangt de Blockshop-drawer: theme:drawer:open met view cart-drawer en klikken op [data-drawer-view="cart-drawer"]
     worden in de capture-fase afgevangen (alleen als window.KBCART.enabled).
   - De inhoud komt uit Liquid (snippets/kb-cart.liquid), na elke wijziging opnieuw opgehaald via /?sections=kb-cart.
   - Eigen cadeaulogica (los van BOGOS), alleen als de theme-instelling kb_gwp_enabled aan staat: precies één giftpack
     van de hoogste bereikte staffel (1 tot 3), plus vanaf staffel 4 één full size product. Eén optie: automatisch erbij.
     Meer opties: de klant kiest in de drawer. Cadeauregels dragen de property _kb_gift (pack of full).
     Gratis maken doen automatische kortingen in de admin (Buy X get Y); dit script zorgt alleen voor de juiste regels.
   - Kortingscode via /cart/update.js { discount }, afteller tot de verzendtijd in Nederlandse tijd. */
(function () {
  'use strict';
  var C = window.KBREC || {};
  var CFG = window.KBCART || {};
  var root = document.querySelector('[data-kbc]');
  if (!root) return;
  var panel = root.querySelector('[data-kbc-panel]');
  var upsell = root.querySelector('[data-kbc-upsell]');
  var OWN = 'X-KB-Cart';

  var state = { open: false, codeOpen: false, code: '', msg: '', msgOk: false, pending: '', seen: null, tierPct: null, shipPct: null, free: null, picker: false, sig: '', lastFocus: null };
  var busy = 0, quietUntil = 0, renderSeq = 0;

  function prefix() { return C.localePrefix === '/' ? '' : (C.localePrefix || ''); }
  function money(cents) {
    var s = (Number(cents || 0) / 100).toFixed(2).replace('.', ',');
    var f = (C.money && C.money.format) || '€{{amount_with_comma_separator}}';
    return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s).replace(/<[^>]+>/g, '');
  }
  function q(sel, el) { return (el || panel).querySelector(sel); }
  function qa(sel, el) { return Array.prototype.slice.call((el || panel).querySelectorAll(sel)); }
  function config() { try { return JSON.parse(q('[data-kbc-config]').textContent); } catch (e) { return null; } }
  function api(path, body) {
    var h = { 'Content-Type': 'application/json', Accept: 'application/json' }; h[OWN] = '1';
    return fetch(prefix() + path, { method: body ? 'POST' : 'GET', headers: h, credentials: 'same-origin', body: body ? JSON.stringify(body) : undefined })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || r.status); e.data = j; throw e; } return j; }); });
  }

  /* ---------- openen en sluiten ---------- */
  function open() {
    if (state.open) { refresh(); return; }
    state.open = true; state.lastFocus = document.activeElement;
    root.setAttribute('data-open', '');
    root.removeAttribute('aria-hidden');
    document.documentElement.classList.add('kbc-lock');
    panel.scrollTop = 0;
    hydrate(true);
    refresh();
    setTimeout(function () { try { panel.focus({ preventScroll: true }); } catch (e) {} }, 50);
  }
  function close() {
    if (!state.open) return;
    state.open = false;
    root.removeAttribute('data-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('kbc-lock');
    panel.style.transform = '';
    if (state.lastFocus && state.lastFocus.focus) try { state.lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }
  window.KBCart = { open: open, close: close, refresh: function () { return refresh(); }, evaluate: function () { return evaluate(); } };

  if (CFG.enabled) {
    // Blockshop: Cart.openDrawer() en elke andere route vuurt theme:drawer:open op window. Capture-listeners op het doel
    // zelf lopen vóór de bubble-listeners van drawer-element, dus de Blockshop-drawer opent niet.
    window.addEventListener('theme:drawer:open', function (e) {
      var d = e.detail || {};
      if (d.view !== 'cart-drawer') return;
      e.stopImmediatePropagation();
      open();
    }, true);
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-drawer-view="cart-drawer"], a[href$="/cart"][data-kbc-open], [data-kbc-open]');
      if (!t) return;
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
      open();
    }, true);
    document.addEventListener('keydown', function (e) {
      var t = e.target.closest && e.target.closest('[data-drawer-view="cart-drawer"]');
      if (t && e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); open(); }
    }, true);
  }
  document.addEventListener('keydown', function (e) {
    if (!state.open) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = qa('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])', root).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // Mobiel: de kop omlaag vegen sluit de bottom sheet.
  (function () {
    var y0 = null, dy = 0;
    panel.addEventListener('touchstart', function (e) {
      if (window.innerWidth >= 768 || !e.target.closest('.kbc__head') || panel.scrollTop > 0) return;
      y0 = e.touches[0].clientY; dy = 0; panel.classList.add('kbc--dragging');
    }, { passive: true });
    panel.addEventListener('touchmove', function (e) {
      if (y0 === null) return;
      dy = Math.max(0, e.touches[0].clientY - y0);
      panel.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });
    panel.addEventListener('touchend', function () {
      if (y0 === null) return;
      panel.classList.remove('kbc--dragging'); y0 = null;
      panel.style.transform = '';
      if (dy > 110) close();
    });
  })();

  /* ---------- verversen ---------- */
  function refresh() {
    var seq = ++renderSeq;
    return fetch(prefix() + '/?sections=kb-cart', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (seq !== renderSeq || !j || !j['kb-cart']) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = j['kb-cart'];
        var next = tmp.querySelector('[data-kbc-inner]');
        var cur = q('[data-kbc-inner]');
        if (!next) return;
        if (upsell && upsell.parentNode !== root) root.appendChild(upsell); // bewaren, niet opnieuw laden
        if (cur) cur.replaceWith(next); else panel.appendChild(next);
        hydrate(false);
      }).catch(function () {});
  }

  function hydrate(first) {
    var cfg = config();
    if (!cfg) return;
    syncHeaderCount(cfg.count);

    // Nieuwe regels schuiven in (alleen regels die er bij de vorige weergave nog niet waren).
    var keys = qa('[data-kbc-key]').map(function (el) { return el.getAttribute('data-kbc-key'); });
    if (state.seen && !first) qa('[data-kbc-key]').forEach(function (el) { if (state.seen.indexOf(el.getAttribute('data-kbc-key')) < 0) el.classList.add('kbc-anim'); });
    state.seen = keys;

    paintTiers(cfg);
    paintShip(cfg);
    placeUpsell(cfg);
    restoreCode();
    tick();
    gift(cfg, first);

    var picker = q('[data-kbc-picker]');
    if (picker && !state.picker && state.open) requestAnimationFrame(function () {
      var top = picker.getBoundingClientRect().top - panel.getBoundingClientRect().top + panel.scrollTop - 16;
      panel.scrollTo({ top: top, behavior: 'smooth' });
    });
    state.picker = !!picker;
  }

  function syncHeaderCount(n) {
    var BS = window.customElements && customElements.get('cart-element');
    if (BS && typeof BS.updateTotals === 'function') try { BS.updateTotals(n); } catch (e) {}
  }

  var ICONS = [
    'M20 12v10H4V12M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z',
    'M7 3h10v18H7zM10 7h4',
    'M12 2l2.4 5.2 5.6.7-4.1 3.9 1.1 5.6L12 14.7l-5 2.7 1.1-5.6L4 7.9l5.6-.7z',
    'M9 2h6v5l3 3v12H6V10l3-3z'
  ];
  function paintTiers(cfg) {
    var box = q('[data-kbc-tiers]');
    if (!box) { state.tierPct = null; return; }
    var all = [];
    cfg.tiers.forEach(function (t, i) { if (t > 0) all.push({ t: t, i: i, r: box.getAttribute('data-r' + (i + 1)), l: box.getAttribute('data-l' + (i + 1)) }); });
    if (!all.length) { box.hidden = true; return; }
    var base = cfg.base;
    var from = all.length > 3 && base >= all[2].t ? 1 : 0;
    var win = all.slice(from, from + 3);
    var lo = from === 0 ? 0 : all[from - 1].t, hi = win[win.length - 1].t;
    var pos = function (t) { return (t - lo) / (hi - lo) * 100; };
    var next = all.filter(function (x) { return base < x.t; })[0];
    q('[data-kbc-tier-text]', box).textContent = next
      ? box.getAttribute('data-next').replace('{amount}', money(next.t - base)).replace('{reward}', next.r)
      : box.getAttribute('data-done');
    var pct = Math.max(0, Math.min(100, (base - lo) / (hi - lo) * 100));
    var fill = q('[data-kbc-tier-fill]', box);
    animateWidth(fill, state.tierPct, pct);
    state.tierPct = pct;
    var marks = qa('.kbc__mark', box), labels = qa('.kbc__marklabels span', box);
    marks.forEach(function (m, k) {
      var x = win[k], lab = labels[k];
      if (!x) { m.hidden = true; lab.hidden = true; return; }
      var p = pos(x.t), on = base >= x.t;
      m.hidden = false; lab.hidden = false;
      m.classList.toggle('is-on', on); lab.classList.toggle('is-on', on);
      m.title = x.l;
      m.style.left = 'calc(' + p + '% - 14px)';
      m.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + ICONS[x.i] + '"/></svg>';
      lab.textContent = x.l;
      lab.style.left = p + '%';
      lab.style.transform = 'translateX(' + (p >= 99 ? 'calc(-100% + 14px)' : p <= 1 ? '-14px' : '-50%') + ')';
    });
  }
  function paintShip(cfg) {
    var bar = q('[data-kbc-ship-pct]');
    var badge = q('.kbc__freeship');
    var free = !!badge;
    if (badge && state.free === false) badge.classList.add('is-new');
    state.free = cfg.shipFree === null ? null : free;
    if (!bar) { state.shipPct = free ? 100 : null; return; }
    var pct = Number(bar.getAttribute('data-kbc-ship-pct')) || 14;
    var fill = q('.kbc__shipfill', bar), truck = q('.kbc__truck', bar);
    var from = state.shipPct === null ? pct : Math.min(state.shipPct, 100);
    fill.style.transition = truck.style.transition = 'none';
    fill.style.width = from + '%'; truck.style.left = from + '%';
    fill.offsetWidth; // reflow
    fill.style.transition = truck.style.transition = '';
    requestAnimationFrame(function () { fill.style.width = pct + '%'; truck.style.left = pct + '%'; });
    state.shipPct = pct;
  }
  function animateWidth(el, from, to) {
    if (!el) return;
    el.style.transition = 'none';
    el.style.width = (from === null ? to : from) + '%';
    el.offsetWidth;
    el.style.transition = '';
    requestAnimationFrame(function () { el.style.width = to + '%'; });
  }

  /* Upsell: het kb-recs-blok blijft bestaan (geen herlaad bij elke render) en wordt in de plek van de nieuwe render gezet.
     Onder de eerste staffel verwijst de kop naar het cadeau. kb-recs ververst de inhoud zelf bij kb:cart. */
  function placeUpsell(cfg) {
    if (!upsell) return;
    var slot = q('[data-kbc-upsell-slot]');
    if (!slot) { upsell.hidden = true; root.appendChild(upsell); return; }
    var low = cfg.tiers[0] > 0 && cfg.base < cfg.tiers[0];
    var t = slot.getAttribute(low ? 'data-low-title' : 'data-title'), s = slot.getAttribute(low ? 'data-low-sub' : 'data-sub');
    upsell.setAttribute('data-kb-title', t); upsell.setAttribute('data-kb-sub', s);
    var tt = upsell.querySelector('.kb-recs__title'), ss = upsell.querySelector('.kb-recs__subtitle');
    if (tt) tt.textContent = t;
    if (ss) { ss.textContent = s; ss.hidden = !s; }
    slot.replaceWith(upsell);
    var sig = qa('[data-kbc-key]').map(function (el) { return el.getAttribute('data-kbc-key'); }).sort().join(',');
    if (sig !== state.sig) {
      state.sig = sig;
      if (upsell.hidden || !upsell.querySelector('.kbr-card')) document.dispatchEvent(new CustomEvent('kb:cart'));
    }
  }

  /* ---------- cadeauknop, overzicht en melding ---------- */
  var wroot = document.querySelector('[data-kbg]');
  function gift(cfg, first) {
    if (!wroot || !CFG.widget) return;
    var list = wroot.querySelector('[data-kbg-list]');
    var tiers = Array.prototype.slice.call(wroot.querySelectorAll('[data-kbg-tier]'));
    if (!tiers.length) return;
    wroot.hidden = false;
    wroot.querySelector('[data-kbg-badge]').textContent = tiers.length;
    var base = cfg.base, reached = 0;
    tiers.forEach(function (li, i) { if (base >= Number(li.getAttribute('data-amount'))) reached = i + 1; });
    tiers.forEach(function (li, i) {
      var amt = Number(li.getAttribute('data-amount')), name = li.getAttribute('data-name');
      li.querySelector('[data-kbg-text]').textContent = list.getAttribute('data-from').replace('[gift]', name).replace('[amount]', money(amt).replace(/,00$/, ''));
      var st = li.querySelector('[data-kbg-state]');
      // Staffels 1 tot 3 sluiten elkaar uit (één pack); staffel 4 komt erbij. Bereikt en de hoogste van 1-3 = actief.
      var on = base >= amt, top = (i + 1 === Math.min(reached, 3)) || (i === 3 && on);
      li.classList.toggle('is-active', on && top);
      li.classList.toggle('is-included', on && !top);
      st.textContent = !on ? list.getAttribute('data-left').replace('[amount]', money(amt - base)) : top ? list.getAttribute('data-active') : list.getAttribute('data-included');
    });
    // Melding bij een hogere staffel; niet bij het laden van de pagina en niet als het cadeau niet door ons wordt gegeven.
    var key = 'kbg_tier', prev = null;
    try { prev = sessionStorage.getItem(key); } catch (e) {}
    if (prev === null || first) { try { sessionStorage.setItem(key, String(Math.max(reached, Number(prev) || 0))); } catch (e) {} return; }
    if (reached > Number(prev)) {
      try { sessionStorage.setItem(key, String(reached)); } catch (e) {}
      if (CFG.gwp) toast(tiers[reached - 1].getAttribute('data-name'));
    }
  }
  var toastTimer = null;
  function toast(name) {
    var t = wroot.querySelector('[data-kbg-toast]'); if (!t) return;
    var txt = t.getAttribute('data-added').replace('[gift]', name);
    t.querySelector('[data-kbg-toast-text]').textContent = txt.charAt(0).toUpperCase() + txt.slice(1);
    t.hidden = false; clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 6000);
  }
  if (wroot) {
    wroot.addEventListener('click', function (e) {
      var panel = wroot.querySelector('[data-kbg-panel]'), btn = wroot.querySelector('[data-kbg-toggle]');
      if (e.target.closest('[data-kbg-toggle]')) { var open = panel.hidden; panel.hidden = !open; btn.setAttribute('aria-expanded', open); wroot.querySelector('[data-kbg-toast]').hidden = true; return; }
      if (e.target.closest('[data-kbg-close]')) { panel.hidden = true; btn.setAttribute('aria-expanded', 'false'); btn.focus(); return; }
      if (e.target.closest('[data-kbc-open]')) { wroot.querySelector('[data-kbg-toast]').hidden = true; }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { var p = wroot.querySelector('[data-kbg-panel]'); if (p && !p.hidden) { p.hidden = true; wroot.querySelector('[data-kbg-toggle]').focus(); } } });
    var c0 = config(); if (c0) gift(c0, true);
  }

  /* ---------- kortingscode ---------- */
  function restoreCode() {
    var box = q('[data-kbc-code]');
    if (!box) return;
    var form = q('[data-kbc-code-form]', box), input = q('[data-kbc-code-input]', box), msg = q('[data-kbc-code-msg]', box), tog = q('[data-kbc-code-toggle]', box);
    form.hidden = !state.codeOpen;
    tog.textContent = box.getAttribute(state.codeOpen ? 'data-hide' : 'data-show');
    input.value = state.code;
    msg.hidden = !state.msg; msg.textContent = state.msg; msg.classList.toggle('is-ok', state.msgOk);
  }
  // Smile-codes: voorvoegsel SMILE of 12 tekens hex (codes van voor het voorvoegsel).
  function isSmile(code) { var c = String(code || ''); return /^SMILE/i.test(c) || /^[0-9a-f]{12}$/i.test(c); }
  function applyCode() {
    var box = q('[data-kbc-code]');
    var code = (state.code || '').trim().toUpperCase();
    if (!code || !box) return;
    busy++;
    api('/cart/update.js', { discount: code })
      .then(function (cart) {
        var hit = (cart.discount_codes || []).filter(function (d) { return String(d.code).toUpperCase() === code; })[0];
        state.pending = '';
        if (hit && hit.applicable) { state.msg = box.getAttribute('data-ok').replace('{code}', code); state.msgOk = true; state.codeOpen = false; }
        // Smile-beloning voor een gratis product: Shopify bewaart de code en past hem toe zodra het product erin ligt.
        // Niet weghalen, wel uitleggen (27-10). Shopify ziet geen verschil tussen onbekend en nog niet van toepassing,
        // daarom alleen voor Smile-codes; andere codes gaan eruit zoals voorheen.
        else if (hit && isSmile(code)) { state.msg = (box.getAttribute('data-pending') || '').replace('{code}', code); state.msgOk = true; state.codeOpen = false; state.pending = code; }
        else { state.msg = box.getAttribute('data-bad'); state.msgOk = false; if (hit) api('/cart/update.js', { discount: '' }).catch(function () {}); }
      })
      .catch(function () { state.msg = box.getAttribute('data-bad'); state.msgOk = false; })
      .then(function () { busy--; quietUntil = Date.now() + 800; return evaluate(); })
      .then(refresh);
  }

  /* ---------- afteller (Nederlandse tijd) ---------- */
  var clockTimer = null;
  function amsterdam() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
      var o = {}; parts.forEach(function (p) { o[p.type] = p.value; });
      var wd = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 }[o.weekday];
      return { day: wd, sec: (+o.hour) * 3600 + (+o.minute) * 60 + (+o.second) };
    } catch (e) { return null; }
  }
  function hm(s) { var p = String(s || '').split(':'); return ((+p[0] || 0) * 60 + (+p[1] || 0)) * 60; }
  function tick() {
    var el = q('[data-kbc-countdown]');
    clearTimeout(clockTimer);
    if (!el) return;
    var now = amsterdam();
    if (!now) { el.hidden = true; return; }
    var days = (el.getAttribute('data-days') || '').split(/[\s,]+/).map(Number);
    var start = hm(el.getAttribute('data-start')), cut = hm(el.getAttribute('data-cutoff'));
    var today = days.indexOf(now.day) >= 0, tomorrow = days.indexOf(now.day % 7 + 1) >= 0;
    var text = '';
    if (today && now.sec >= start && now.sec < cut) {
      var left = cut - now.sec, h = Math.floor(left / 3600), m = Math.floor(left % 3600 / 60);
      var tf = h ? (CFG.timeHM || '{h}u {m}m') : (CFG.timeM || '{m}m');
      text = el.getAttribute('data-before').replace('{time}', tf.replace('{h}', h).replace('{m}', m));
    } else if (now.sec >= cut && tomorrow) {
      text = el.getAttribute('data-late');
    }
    el.hidden = !text;
    var t = q('[data-kbc-countdown-text]', el); if (t) t.textContent = text;
    if (state.open) clockTimer = setTimeout(tick, 1000 - (Date.now() % 1000));
  }

  /* ---------- acties ---------- */
  panel.addEventListener('click', function (e) {
    var t = e.target;
    var closeBtn = t.closest('[data-kbc-close]');
    if (closeBtn) { if (closeBtn.tagName !== 'A') e.preventDefault(); close(); return; }
    var qty = t.closest('[data-kbc-qty]');
    if (qty) { change(qty.closest('[data-kbc-key]'), Number(qty.getAttribute('data-kbc-qty'))); return; }
    var add = t.closest('[data-kbc-add]');
    if (add) { addFavorite(add); return; }
    var pick = t.closest('[data-kbc-gift-pick]');
    if (pick) { pickGift(pick); return; }
    if (t.closest('[data-kbc-gift-change]')) { changeGift(); return; }
    if (t.closest('[data-kbc-code-toggle]')) { state.codeOpen = !state.codeOpen; state.msg = ''; restoreCode(); if (state.codeOpen) { var i = q('[data-kbc-code-input]'); if (i) i.focus(); } return; }
    if (t.closest('[data-kbc-code-apply]')) { applyCode(); return; }
  });
  panel.addEventListener('input', function (e) {
    if (e.target.matches('[data-kbc-code-input]')) { state.code = e.target.value.toUpperCase(); e.target.value = state.code; if (state.msg) { state.msg = ''; restoreCode(); } }
  });
  panel.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-kbc-code-input]')) { e.preventDefault(); applyCode(); }
  });
  panel.addEventListener('submit', function (e) {
    var b = e.target.querySelector('.kbc__checkout'); if (b) b.setAttribute('aria-busy', 'true');
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { var b = q('.kbc__checkout'); if (b) b.removeAttribute('aria-busy'); refresh(); } });

  function change(line, qty) {
    if (!line) return;
    line.classList.add('is-busy');
    busy++;
    api('/cart/change.js', { id: line.getAttribute('data-kbc-key'), quantity: Math.max(0, qty) })
      .catch(function () {})
      .then(function () { busy--; quietUntil = Date.now() + 800; return evaluate(); })
      .then(refresh);
  }
  function addFavorite(btn) {
    btn.disabled = true;
    busy++;
    api('/cart/add.js', { items: [{ id: Number(btn.getAttribute('data-kbc-add')), quantity: 1 }] })
      .then(function (r) {
        btn.classList.add('is-done'); btn.textContent = '✓';
        var it = r && r.items && r.items[0];
        if (it) document.dispatchEvent(new CustomEvent('theme:cart:productAdded', { detail: { product_id: it.product_id, kb_placement: 'cart_empty' } }));
      })
      .catch(function () { btn.disabled = false; })
      .then(function () { busy--; quietUntil = Date.now() + 800; return evaluate(); })
      .then(function () { setTimeout(refresh, 450); });
  }
  function pickGift(btn) {
    qa('[data-kbc-gift-pick]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); b.disabled = true; });
    busy++;
    api('/cart/add.js', { items: [{ id: Number(btn.getAttribute('data-kbc-gift-pick')), quantity: 1, properties: { _kb_gift: 'full' } }] })
      .catch(function () {})
      .then(function () { busy--; quietUntil = Date.now() + 800; return evaluate(); })
      .then(function () { setTimeout(refresh, 350); });
  }
  function changeGift() {
    busy++;
    api('/cart.js').then(function (cart) {
      var up = {};
      cart.items.forEach(function (i) { if (i.properties && i.properties._kb_gift === 'full') up[i.key] = 0; });
      return Object.keys(up).length ? api('/cart/update.js', { updates: up }) : null;
    }).catch(function () {})
      .then(function () { busy--; quietUntil = Date.now() + 800; state.picker = false; return refresh(); });
  }

  /* ---------- eigen cadeaulogica ---------- */
  var evaluating = null, again = false;
  // Onthoudt per sessie welke code het cadeau blokkeert, zodat het na herladen niet even terugkomt.
  var giftBlock = null;
  try { giftBlock = sessionStorage.getItem('kbc_gift_block'); } catch (e) {}
  function setBlock(v) { giftBlock = v; try { if (v) sessionStorage.setItem('kbc_gift_block', v); else sessionStorage.removeItem('kbc_gift_block'); } catch (e) {} }
  // Een opgeslagen Smile-code wordt vanzelf actief zodra het product erin ligt: melding dan bijwerken.
  function checkPending() {
    if (!state.pending) return;
    var code = state.pending;
    api('/cart.js').then(function (cart) {
      if (state.pending !== code) return;
      var hit = (cart.discount_codes || []).filter(function (d) { return String(d.code).toUpperCase() === code; })[0];
      var box = q('[data-kbc-code]');
      if (!hit) { state.pending = ''; state.msg = ''; }
      else if (hit.applicable && box) { state.pending = ''; state.msg = box.getAttribute('data-ok').replace('{code}', code); state.msgOk = true; }
      else return;
      restoreCode();
    }).catch(function () {});
  }
  function evaluate() {
    checkPending();
    var cfg = config();
    if (!cfg || !cfg.gwp) return Promise.resolve(false);
    if (evaluating) { again = true; return evaluating; }
    var rounds = 0, changed = false;
    function round() {
      rounds++;
      return api('/cart.js').then(function (cart) {
        var packs = (cfg.packs || []).map(function (p) { return p ? p.variant : null; });
        var fulls = (cfg.full || []).filter(Boolean).map(function (p) { return p.variant; });
        var isPack = function (i) { return (i.properties && i.properties._kb_gift === 'pack') || packs.indexOf(i.variant_id) >= 0; };
        var isFull = function (i) { return i.properties && i.properties._kb_gift === 'full'; };
        // Klonen van de oude Free Gifts-app (BOGOS) horen na de overstap niet meer in de winkelwagen.
        var isClone = function (i) { return /-sca_clone_freegift$/.test(i.handle || ''); };
        var giftSum = 0;
        cart.items.forEach(function (i) { if (isPack(i) || isFull(i) || isClone(i)) giftSum += i.final_line_price; });
        // Smile-loyaltycodes tellen niet mee voor de cadeaudrempel (besluit Tamar 26-10); andere kortingen wel.
        var smileOff = 0;
        (cart.cart_level_discount_applications || []).forEach(function (d) { if (d.type === 'discount_code' && isSmile(d.title)) smileOff += d.total_allocated_amount || 0; });
        cart.items.forEach(function (i) { (i.line_level_discount_allocations || []).forEach(function (a) { var d = a.discount_application || {}; if (d.type === 'discount_code' && isSmile(d.title)) smileOff += a.amount || 0; }); });
        var base = cart.total_price - giftSum + smileOff;
        var target = null;
        for (var k = 2; k >= 0; k--) if (cfg.tiers[k] > 0 && base >= cfg.tiers[k] && packs[k]) { target = packs[k]; break; }
        var t4 = cfg.tiers[3];
        var fullOk = t4 > 0 && base >= t4;
        // Vangnet: een kortingscode die niet met productkortingen combineert (zoals de Smile-beloning voor een gratis
        // product) maakt het cadeau niet meer gratis. Zolang zo'n code actief is voegen we geen cadeau toe.
        var codes = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return String(d.code).toUpperCase(); }).join(',');
        var paidGift = cart.items.some(function (i) { return (isPack(i) || isFull(i)) && i.final_line_price > 0; });
        if (paidGift && codes) setBlock(codes);
        if (giftBlock && giftBlock !== codes) setBlock(null);
        if (giftBlock) { target = null; fullOk = false; }
        var updates = {}, adds = [], havePack = false, haveFull = false;
        cart.items.forEach(function (i) {
          if (isClone(i)) { updates[i.key] = 0; return; }
          if (isPack(i)) {
            if (i.variant_id === target && !havePack) { havePack = true; if (i.quantity !== 1) updates[i.key] = 1; }
            else updates[i.key] = 0;
          } else if (isFull(i)) {
            if (fullOk && !haveFull && fulls.indexOf(i.variant_id) >= 0) { haveFull = true; if (i.quantity !== 1) updates[i.key] = 1; }
            else updates[i.key] = 0;
          }
        });
        if (target && !havePack) adds.push({ id: target, quantity: 1, properties: { _kb_gift: 'pack' } });
        if (fullOk && !haveFull && fulls.length === 1) adds.push({ id: fulls[0], quantity: 1, properties: { _kb_gift: 'full' } });
        var work = Promise.resolve();
        if (Object.keys(updates).length) { changed = true; work = work.then(function () { return api('/cart/update.js', { updates: updates }); }); }
        if (adds.length) { changed = true; work = work.then(function () { return api('/cart/add.js', { items: adds }); }); }
        return work.then(function () { if ((Object.keys(updates).length || adds.length) && rounds < 2) return round(); });
      });
    }
    evaluating = round().catch(function (e) { if (window.console) console.warn('[kb-cart] cadeaus', e); })
      .then(function () {
        evaluating = null; quietUntil = Date.now() + 800;
        if (changed) syncBlockshop();
        if (again) { again = false; return evaluate(); }
        return changed;
      });
    return evaluating;
  }
  function syncBlockshop() {
    var BS = window.customElements && customElements.get('cart-element');
    if (BS && typeof BS.fetchBasket === 'function') BS.fetchBasket().catch(function () {});
  }

  /* ---------- wijzigingen van anderen (theme, apps) ---------- */
  var extTimer = null;
  function external() {
    if (busy || Date.now() < quietUntil) return;
    clearTimeout(extTimer);
    extTimer = setTimeout(function () {
      if (busy || Date.now() < quietUntil) return;
      evaluate().then(function () { refresh(); });
    }, 300);
  }
  document.addEventListener('kb:cart', external);
  window.addEventListener('theme:cart:updated', external);
  // XHR-route (sommige apps gebruiken geen fetch); fetch vangt kb-track al op en meldt het via kb:cart.
  (function () {
    var X = window.XMLHttpRequest && window.XMLHttpRequest.prototype;
    if (!X || X.__kbc) return;
    var o = X.open, s = X.send;
    X.open = function (m, url) { this.__kbcUrl = String(url || ''); return o.apply(this, arguments); };
    X.send = function () {
      if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(this.__kbcUrl || '')) this.addEventListener('loadend', external);
      return s.apply(this, arguments);
    };
    X.__kbc = true;
  })();

  // Bij het laden: de cadeauregels rechtzetten (bijvoorbeeld na een wijziging op de cartpagina of in een ander tabblad).
  if (CFG.enabled) setTimeout(function () { var c = config(); if (c && c.gwp && (C.cart || []).length) evaluate().then(function (ch) { if (ch) refresh(); }); }, 800);
  root.setAttribute('aria-hidden', 'true');
})();
